import { httpGet, httpPost } from '@/utils/requestEx'


export default {
  // 登录
  Login (data) {
    return httpPost('/api/Account/login', data)
  },

  // 修改密码
  ChangePwd (data) {
    return httpPost('/api/Account/change-password', data)
  },

  //获取案例列表
  GetCaseList (data) {
    return httpGet('/api/Case/list', data)
  },

  //获取所有案例记录
  GetCaseRecords (data) {
    return httpGet('/api/Case/records', data)
  },

  // 交卷 
  CaseSubmit (data) {
    return httpPost('/api/Case/submit', data)
  },

  // 获取答案解析
  GetCaseAnalysis (data) {
    return httpPost('/api/Case/getanalysis', data)
  },

  //获取案例附件
  GetAttachment (data) {
    return httpGet('/api/Case/getAttachment', data)
  },

  //删除学生工作流数据
  DeleteWorkflowData (data) {
    return httpGet('/api/Case/deleteWorkflowData', data)
  },

  //获取信贷模拟数据
  GetMockCreditReport (data) {
    return httpGet('/api/Credit/getMockCreditReport', data)
  }

}